(ns manage.ad-variant.creation.strategy.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/CircularProgress$default" :as CircularProgress]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/FormControlLabel$default" :as FormControlLabel]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/InputAdornment$default" :as InputAdornment]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Switch$default" :as Switch]
            ["@mui/material/TextField$default" :as TextField]
            ["@mui/material/ToggleButton$default" :as ToggleButton]
            ["@mui/material/ToggleButtonGroup$default" :as ToggleButtonGroup]
            ["@mui/material/Typography$default" :as Typography]
            [manage.ad-variant.creation.feed.mapping.view
             :refer [feed-error-boundary]]
            [manage.ad-variant.creation.strategy.hooks :as h]
            [uix.core :as uix :refer [$ defui]]))

(def separator-options
  [{:label "Comma" :value ","}
   {:label "Period" :value "."}
   {:label "Semicolon" :value ";"}
   {:label "Whitespace" :value " "}])

(defui search-field [{:keys [search-term set-search-term]}]
  ($ TextField
     {:placeholder "Search targeting columns"
      :value search-term
      :onChange #(set-search-term (.. % -target -value))
      :size "small"
      :sx #js {:width 320}
      :InputProps #js {:startAdornment
                       ($ InputAdornment {:position "start"} ($ Icon "search_icon"))}}))

(defui separator-selector []
  (let [{:keys [selected-separator set-selected-separator is-any-multi-value]}
        (h/use-separator-controls)]
    ($ Stack {:direction "row"
              :alignItems "center"
              :spacing 1}
       ($ Typography {:sx #js {:color "grey.20"}}
          "Separator")
       ($ ToggleButtonGroup
          {:value (when is-any-multi-value selected-separator)
           :disabled (not is-any-multi-value)
           :exclusive true
           :onChange (fn [_ value] (set-selected-separator value))
           :size "small"}
          (for [{:keys [value label]} separator-options]
            ($ ToggleButton {:key value :value value}
               (str label " (" value ")")))))))

(defui select-all-button []
  (let [{:keys [set-all-selection is-all-selected]} (h/use-select-all-controls)]
    ($ Button {:size "small"
               :onClick (partial set-all-selection (not is-all-selected))}
       (if is-all-selected
         "Deselect all"
         "Select all"))))

(defui available-columns [{:keys [matches-search-term?]}]
  (let [{:keys [toggle-column-selection columns]} (h/use-select-single-controls)]
    ($ Stack {:spacing 2}
       ($ Stack {:justifyContent "space-between"
                 :alignItems "center"
                 :direction "row"}
          ($ Typography {:sx #js {:fontWeight 500 :color "grey.20"}}
             "Available columns")
          ($ select-all-button))

       ($ Stack {:direction "row"
                 :spacing 1
                 :useFlexGap true
                 :sx #js {:flexWrap "wrap"
                          :rowGap 1}}
          (for [[column {:keys [selected]}] (sort columns)
                :when (matches-search-term? column)]
            ($ Chip {:key column
                     :label column
                     :onClick #(toggle-column-selection column)
                     :variant "outlined"
                     :size "large"
                     :color (if selected "primary" "")
                     :icon (when selected ($ Icon "checkmark"))
                     :sx #js {:borderRadius 3
                              :color (when-not selected "grey.20")
                              :fontWeight "600"}}))))))

(defui selected-columns []
  (let [{:keys [columns toggle-multi-value]} (h/use-multi-value-controls)]
    ($ Stack {:spacing 2}
       ($ Typography {:sx #js {:fontWeight 500 :color "grey.20"}}
          (str "Selected strategy columns ("
               (count (filter (comp :selected val) columns))
               ")"))

       ($ Stack {:spacing 1}
          (for [[column {:keys [multi-value selected]}] (sort columns)
                :when selected]
            ($ Stack {:key column
                      :justifyContent "space-between"
                      :alignItems "center"
                      :direction "row"
                      :sx #js {:p 1.5
                               :borderRadius 1
                               :bgcolor "grey.80"}}
               ($ Typography
                  {:sx #js {:fontWeight 500 :color "grey.20"}}
                  column)
               ($ FormControlLabel
                  {:control ($ Switch
                               {:checked (boolean multi-value)
                                :onChange #(toggle-multi-value column)
                                :size "small"
                                :color "primary"
                                :sx #js {:mr 1}})
                   :label "Multi value"
                   :labelPlacement "end"})))))))

(defui strategy-header []
  ($ Typography {:variant "h3"}
     "Select and classify the strategy columns "
     ($ Typography {:component "span" :color "grey.20"} "(Optional)")))

(defui strategy-form []
  (let [search-state (h/use-search-state)]

    ($ Stack {:spacing 3
              :sx #js {:pt 2}}

       ($ strategy-header)

       ($ Stack {:direction "row"
                 :alignItems "center"
                 :justifyContent "space-between"}
          ($ search-field search-state)

          ($ separator-selector))

       ($ available-columns search-state)

       ($ Divider)

       ($ selected-columns))))

(defui strategy-view []
  ($ feed-error-boundary
     ($ uix/suspense {:fallback ($ Stack
                                   {:height "100%"
                                    :alignItems "center"
                                    :justifyContent "center"}
                                   ($ CircularProgress))}
        ($ strategy-form))))
